import { useContext } from 'react';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';
import FacetDataContext from '~/context/common/FacetDataContext';
import Checkbox from '../Checkbox';

type OwnProps = {
  count: number;
  make: string;
  model: string;
};

export default function ParentModel({ count, make, model }: OwnProps) {
  const { appliedFilters, updateMakes } = useContext(AppliedFiltersContext);
  const { showInventoryCounts } = useContext(FacetDataContext);

  const appliedMakes = appliedFilters?.makes?.find(
    appliedMake => appliedMake.name === make
  );

  const isSelected = appliedMakes?.parentModels?.some(
    appliedModel => appliedModel.name === model
  );

  return (
    <Checkbox
      facet="parent-models"
      filter={model}
      id={`parent-model-${model}`}
      checked={isSelected}
      onChange={() =>
        updateMakes({
          modelsKey: 'parentModels',
          name: model,
          parents: [make]
        })
      }
      label={
        showInventoryCounts ? `${model} (${count.toLocaleString()})` : model
      }
    />
  );
}
